<div ngbDropdown #dropdown="ngbDropdown" 
    (openChange)="openChange($event, tempFilterInfo)" 
    class="edp-select-list">
    <div ngbDropdownToggle [ngClass]="{ 'filtered': tempFilterInfo.hasOptionSelected, 'clicked': tempFilterInfo.clicked }"
        class="d-flex justify-content-center align-items-center btn-filter-border cursor-pointer">
        <a class="btn-filter-label">{{ tempFilterInfo.name | translate }}</a>
    </div>
    <div ngbDropdownMenu aria-labelledby="ddForm" class="select-list">
        <form class="pt-4-sa pb-0 d-flex flex-column h-100 form-back edp-form">
            <div class="px-4">
                <span class="pt-2-sa d-block d-md-none text-right btn btn-close" ngbDropdownToggle>
                    <i class="icon-edponline-Bop-071 cursor-pointer icon-2x"  aria-hidden="true"></i>
                </span>
                <span class="d-md-none d-block my-2 filter-name" *ngIf="!tempFilterInfo.mobileCollapsable">{{ tempFilterInfo.name | translate }}</span>

                <div *ngFor="let filter of tempFilters">
                    <ng-container *ngFor="let option of filter.options;">
                        <label class="form-check-label">
                            <input #checkboxOpt type="checkbox" class="form-check-input"
                                id="option{{filter.id}}{{option.id}}"
                                [attr.filter]="filter.id"
                                [attr.option]="option.id"
                                [checked]="option.selected">
                            <span class="form-check-mark"></span>
                            <span class="form-check-name d-block pt-1">{{ option.name | translate }}</span>
                        </label>
                    </ng-container>
                </div>
            </div>            
            <div class="d-flex flex-row justify-content-between footer py-3 mt-auto">
                <button type="button" (click)="clearFilter()" class="btn btn-dropdown-clear py-1 pl-0">
                    {{ 'pt.edp.edponline.benefits.filter.reset' | translate  }}</button>
                <button type="button" (click)="applyFilter(tempFilterInfo, tempFilters);" class="btn btn-dropdown-submit py-1 pr-0">
                    {{ 'pt.edp.edponline.benefits.filter.apply' | translate }}</button>
            </div>
        </form>
    </div>
</div>